import BaseApi from './base/BaseApi';

export default class CrmServiceTypeApi extends BaseApi {
  static entityName = 'crm_service_types';
}
